import { localStorageSync } from 'ngrx-store-localstorage';

export const localStorageSyncReducer = (reducer: any): any => {
  return localStorageSync({
    keys: ['menu'],
    rehydrate: true,
    removeOnUndefined: true
  })(reducer);
};
